import { useState } from 'react';

/**
 * Holds what a ConfirmDialog asks to remove, keeping it open with the refusal or closing it once removed.
 * The target outlives `open` so the dialog still names it while it fades out.
 */
export const useConfirmedRemoval = <T extends { id: string }>(remove: (target: T) => Promise<string | null>) => {
  const [target, setTarget] = useState<T | null>(null);
  const [open, setOpen] = useState(false);
  const [refusal, setRefusal] = useState<string | null>(null);

  const ask = (next: T) => {
    setTarget(next);
    setRefusal(null);
    setOpen(true);
  };

  const cancel = () => setOpen(false);

  const confirm = async () => {
    if (!target) return;
    const refused = await remove(target);
    if (refused) setRefusal(refused);
    else cancel();
  };

  return { target, open, refusal, ask, cancel, confirm };
};
